import { render, staticRenderFns } from "./SingleNotice.vue?vue&type=template&id=2ba3daa7&scoped=true&"
import script from "./SingleNotice.vue?vue&type=script&lang=js&"
export * from "./SingleNotice.vue?vue&type=script&lang=js&"
import style0 from "./SingleNotice.vue?vue&type=style&index=0&id=2ba3daa7&lang=scss&scoped=true&"
import style1 from "./SingleNotice.vue?vue&type=style&index=1&id=2ba3daa7&scoped=true&lang=css&"
import style2 from "./SingleNotice.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba3daa7",
  null
  
)

export default component.exports